import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @Input() component: any;
  @Input() formDesign: any;
  @Output() onChangeEmitter: any = new EventEmitter();
  @Input() formState: any;

  myState: any = [];
  
  constructor() {}

  ngOnInit() {
    if(this.formState) {
      this.myState = this.formState[this.component.element.field_name] || []
    }
  }

  ngOnChanges(c: any) {
    if(this.formState) {
      this.myState = this.formState[this.component.element.field_name] || []
    }
  }

  ngDoCheck() {
    if(this.formState && this.formState[this.component.element.field_name] != this.myState) {
      this.myState = this.formState[this.component.element.field_name] || []
    }
  }

  onRowAdd() {
    this.onChangeEmitter.emit({ 
      component: this.component, 
      eventType: "rowAdd",
    })
  }

  onCellChange(row: number, col: any, e: any){
    console.log(row, col, e)
    this.onChangeEmitter.emit({ 
      component: this.component, 
      eventType: "valueChange",
      row: row,
      col: col,
      value: col.valueType == 'checkbox' ? e.target.checked : e.target.value,
    })
  }

  onChange(e: any) {
    this.onChangeEmitter.emit({ component: this.component, value: e.target.checked })
  }

  onRowRemove() {
    this.onChangeEmitter.emit({ 
      component: this.component, 
      eventType: "rowRemove",
    })
  }
}
